import * as React from 'react'
import Message from './Message'
import Router from 'next/router'

const Context = React.createContext(null)
let uniqueId = 1
export default Context

export function useMessage() {
  return React.useContext(Context)
}

export const MessageProvider = ({ children }) => {
  const [{ current, queue }, setState] = React.useState({
    current: null,
    queue: [],
  })

  const sendMessage = (message, type = 'info', options = {}) => {
    const id = uniqueId++
    const snack = { id, message, open: true, options, type }

    setState(({ current, queue }) =>
      current
        ? { current, queue: queue.concat(snack) }
        : { current: snack, queue }
    )

    return id
  }

  const flashMessage = message => {
    localStorage.setItem('flashMessage', message)
  }

  const handleClose = () => {
    setState(currentState => ({
      ...currentState,
      current: { ...currentState.current, open: false },
    }))
    // time to snack close animation
    setTimeout(openNext, 1000)
  }

  const openNext = () => {
    setState(({ current, queue }) =>
      queue.length
        ? { current: queue[0], queue: queue.slice(1) }
        : { current: null, queue: [] }
    )
  }

  React.useEffect(() => {
    const handleRouteChange = () => {
      const flashMessage = popFlashMessage()
      if (flashMessage) sendMessage(flashMessage, 'info')
    }

    Router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      Router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [])

  return (
    <Context.Provider value={{ sendMessage, flashMessage }}>
      {current && (
        <Message key={current.id} {...current} handleClose={handleClose} />
      )}
      {children}
    </Context.Provider>
  )
}

function popFlashMessage() {
  const flashMessage = localStorage.getItem('flashMessage')
  localStorage.removeItem('flashMessage')

  return flashMessage
}
